<template>
	<AsiDialogFormLayout v-if="model !== null" :icon="icons.trimmingCostThreshold"
	                     :title="$t('globalConfig.terms.bulkOfferThreshold')"
	                     :open="open" :loading="loading" :valid="valid" :errors="errors"
	                     @save="requestSave" @cancel="cancel" unwrapped scrollable>
		<v-card-text class="pa-0">
			<v-form ref="form" v-model="valid">
				<div class="pa-6">
					<v-row>
						<v-col>
							<AsiTextField v-model="model.bulkOfferThresholdMeters"
							              :rules="model.rules('bulkOfferThresholdMeters')"
							              :label="$t('globalConfig.terms.bulkOfferThresholdMeters')"
							              :placeholder="$t('globalConfig.terms.bulkOfferThresholdMeters')"
							              :suffix="$t('constants.unitMeter')" clearable
							              @keydown.enter.prevent="requestSave"/>
						</v-col>
					</v-row>
				</div>
			</v-form>
		</v-card-text>
	</AsiDialogFormLayout>
</template>

<script lang="ts">
	import {Component, Emit, Prop} from "vue-property-decorator";
	import AsiDialogFormLayout from "../../common/AsiDialogFormLayout.vue";
	import AsiDialogForm from "@/components/common/AsiDialogForm.vue";
	import AsiTextField from "@/components/common/AsiTextField";
	import {IGlobalConfigAdmin} from "@/models/global-config/GlobalConfigAdminModels";
	import GlobalConfigUpdateBulkOfferThreshold from "@/models/global-config/GlobalConfigUpdateBulkOfferThreshold";

	@Component({
		components: {AsiTextField, AsiDialogFormLayout}
	})
	export default class GlobalConfigUpdateDialogBulkOfferThreshold extends AsiDialogForm {

		@Prop({type: Object, required: true})
		public globalConfig!: IGlobalConfigAdmin;

		private model: GlobalConfigUpdateBulkOfferThreshold | null = null;

		public created(): void {
			this.setGlobalConfigInternal();
		}

		private setGlobalConfigInternal(): void {
			if (this.globalConfig === null) {
				this.model = null;
				return;
			}

			if (this.model === null) {
				this.model = new GlobalConfigUpdateBulkOfferThreshold(this.globalConfig);
				this.valid = true;
			} else {
				this.model.setDetailModel(this.globalConfig);
			}
		}

		private requestSave(): void {
			if (this.model === null) return;

			this.loading = true;
			this.$globalConfigServiceAdmin.updateBulkOfferThreshold(this.model)
				.then(this.save)
				.catch(this.handleErrors)
				.finally(() => this.loading = false);
		}

		@Emit('save')
		public save(): void {
			return;
		}

		@Emit('cancel')
		public cancel(event: Event): Event {
			this.setGlobalConfigInternal();
			const form = this.$refs.form as HTMLFormElement;
			this.reset([], form);
			return event;
		}

	}
</script>
